import React from "react";

/* =======================
   Styles
======================= */
import styles from "./StatsBox.module.scss";

const StatsBox = ({ title, value, subText, icon, type }) => {
  // Map the incoming 'type' to our specific SCSS modifier class
  const typeClass = type ? styles[`stats-box--${type}`] : "";

  return (
    <div className={`${styles["stats-box"]} ${typeClass}`}>
      <div className={styles["stats-box__top"]}>
        <p className={styles["stats-box__title"]}>{title}</p>

        {/* Render the Lucide React node */}
        <div className={styles["stats-box__icon-wrapper"]}>{icon}</div>
      </div>

      <div className={styles["stats-box__content"]}>
        <h3 className={styles["stats-box__value"]}>{value}</h3>

        {subText && (
          <small className={styles["stats-box__subtext"]}>{subText}</small>
        )}
      </div>
    </div>
  );
};

export default StatsBox;
